import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {

  public quickLinks = [
    {
      title: 'About',
      link: '/about',
      icon: 'Magnify_icon.png',
      description: 'Learn a little more about CoolTech, including an overview of the broad range of services we ' +
                   'provide, to begin to better understand how we can help you with all of your refrigeration needs.'
    },
    {
      title: 'Ice Machines',
      link: '/ice-machines',
      icon: 'Snowflake_icon.jpg',
      description: 'As ice machine experts, CoolTech offer sales, professional installation, diagnosis, service, ' +
                   'repair, and cleaning of all makes and models of ice machines and water dispensers.'
    },
    {
      title: 'Commercial Refrigeration',
      link: '/commercial-refrigeration',
      icon: 'Truck_icon.png',
      description: 'With a 24/7 breakdown service, CoolTech offer reliable solutions for commercial refrigeration, ' +
                   'including maintenance, installation and repair of Commercial fridges and cool rooms.'
    }
  ];
}



// WEBPACK FOOTER //
// ./src/app/pages/home/home.component.ts